import React from 'react';
import Dumbo from '../../../../../DeviationViews/Dumbo';
import { useCurrentTier } from '../../../../_hocs/withCurrentTier';
import s from './TierSidebar.scss';
const TierSidebar = (props)=>{
    const { currentTier  } = useCurrentTier();
    if (!currentTier) {
        return null;
    }
    const coverWidth = 343;
    const coverHeight = 224;
    const coverImage = currentTier.coverImage;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['sidebar']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['cover-wrapper']
    }, coverImage && /*#__PURE__*/ React.createElement(Dumbo, {
        className: s['cover'],
        deviation: coverImage,
        width: coverWidth,
        height: coverHeight
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['form']
    }, /*#__PURE__*/ React.createElement("h1", null, currentTier.title))));
};
TierSidebar.displayName = 'TierSidebar';
export default TierSidebar;
